import { useDispatch, useSelector } from "react-redux";
import { redirectToUrl } from "~/utils/url/urlUtils";
import AuthOverlay from "./AuthOverlay";
import {
  selectAuthOverlayOptions,
  selectAuthView,
  selectIsAuthOverlayOpen,
} from "~/features/registration/components/redux/AuthSelectors";
import { closeAuthOverlay } from "~/features/registration/components/redux/AuthActions";

export const AuthOverlayHost = () => {
  const dispatch = useDispatch();
  const isAuthOpen = useSelector(selectIsAuthOverlayOpen);
  const authView = useSelector(selectAuthView);
  const authOptions = useSelector(selectAuthOverlayOptions);

  if (!isAuthOpen) {
    return null;
  }

  return (
    <AuthOverlay
      handleClose={() => dispatch(closeAuthOverlay())}
      initialView={authView}
      initialEmail={authOptions.initialEmail}
      alternativeGAAction={authOptions.alternativeGAAction}
      alternativeLoginAction={
        authOptions.alternativeLoginRedirectUrl
          ? () => redirectToUrl(authOptions.alternativeLoginRedirectUrl!)
          : undefined
      }
    />
  );
};
